export default __webpack_public_path__ + "static/compareItemImg1-a828376a138060c06cf71d5f713e7efb.png";